import { MemberEventsService } from '../../../services/member.events.service';
import { Subscription } from 'rxjs';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { EntityChangedArgs } from '../../../managers/manager.base';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { ActivityItemArray } from '../../../../app/models/domain/activity.item';
import { regex } from '../../../../app/shared/regex';
import { LicenseManager } from '../../../managers/License.manager';
import { ConversationThreadMessageArray } from '@models/domain/conversation.thread.message';
import { ConversationHistoryDialog } from 'app/dialogs/conversation.history/conversation.history.dialog';
import { DialogService } from '@services/modal-dialogs';

@Component({
    selector: 'member-activity-stream',
    templateUrl: './member.activity.stream.component.html',
    styleUrls: ['./member.activity.stream.component.scss']
})
export class MemberActivityStreamComponent implements OnInit, OnDestroy {
    ActivitySearch: String;
    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    IsBusy: boolean = false;
    @Input('MemberID') MemberID: number;
    @Input('ActivityItems') ActivityItems: ActivityItemArray;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    private subscriptions = new Array<Subscription>();

    constructor(private api: ssApiService, private memberEvents: MemberEventsService, private windowService: WindowService, private dialogService: DialogService) { }

    ngOnInit() {
        this.SubscribeEvents();
    }

    ngOnDestroy() {
        this.UnsubscribeEvents();
    }

    UnsubscribeEvents() {
        if (this.subscriptions != null)
            this.subscriptions.forEach((s) => { s.unsubscribe() });
    }

    SubscribeEvents() {
        // memberevents
        let memberEvents = this.memberEvents.onNoteChanged.subscribe((args: EntityChangedArgs<any>) => {
            // this.CheckNoteChanged(args);
            return true;
        })
        this.subscriptions.push(memberEvents);
    }

    IsLicenseKey(possibleKey: string) {
        return regex.IsPossibleLicenseKey(possibleKey);
    }

    IsConversationThread(possibleThread: string){
        if (possibleThread){
            return possibleThread.startsWith("CNVTHD-");
        }
    }    

    LicenseClick(key: string): void {
        // var windowSettings = new WindowSettings();
        // windowSettings.Height = 900;
        // windowSettings.Width = 1240;

        // this.windowService.OpenWindow<string>(WindowTypes.License, key, windowSettings);
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {})
    }

    onConversationClick(conversationID: string): void {
        this.IsBusy = true;
        let title: string;
        title = "Conversation History";
    
        let options = {
            height: 800
        }

        let data: ConversationThreadMessageArray = [];

        let id = Number(conversationID.replace("CNVTHD-", ""));

        let convoDisposable = this.api.getConversationThreadMessages(id).subscribe(response => {
            data = response.Data;
            convoDisposable.unsubscribe();

            let disposable = this.dialogService.addDialog(ConversationHistoryDialog, {
                title: title,
                subTitle: "",
                message: 'Confirm message',
                conversationMessages: data
            }, options).subscribe(response => {
                disposable.unsubscribe();
                this.IsBusy = false;
            });
    
        });        

    }    

    paginateActivityStream(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    FileNameForPath(path) {
        return path.match(new RegExp(/[^\\]*$/))[0];
    }

}
